// DashboardService.js
import api from '../../utils/ApiConfig';
// Fetch all KPI from the database
const fetchKpiData = async (periodData) => {
    try {
      const response = await api.get(`/kpi/panier`, { params: periodData });
      if (response.data.error) {
        throw new Error(response.data.error); // Gérer l'erreur en fonction de la structure de réponse
      }
      return response.data;  // retourner les informations
    } catch (error) {
      console.error('Error saving Kpi data:', error);
      throw error;
    }
  }

// Fetch pending and urgent supplier orders
const fetchPendingSupplierOrders = async () => {
  try {
    // Récupère les commandes avec statuts : 4 (validation), 3 (préparation), 1 (livraison)
    // Filtre : toutes les commandes en retard + aujourd'hui + demain
    // Tri par date de livraison croissante
    const response = await api.get(`/fo/getPendingUrgentSupplierOrders`);
    return response.data;
  } catch (error) {
    console.error('Error fetching pending supplier orders:', error);
    throw error;
  }
}

// Fetch all delivery drivers positions (geolocation)
const fetchLivreursPositions = async () => {
  try {
    const response = await api.get(`/admin/livreurs/positions`);
    if (response.data.error) {
      throw new Error(response.data.error);
    }
    return response.data;
  } catch (error) {
    console.error('Error fetching livreurs positions:', error);
    throw error;
  }
}

// Export methods ************************************************************
export {fetchKpiData, fetchPendingSupplierOrders, fetchLivreursPositions}